import * as tslib_1 from "tslib";
import { ConflictStrategyBase } from "../library/ConflictStrategyBase";
import { ErrorBase } from "../errors/ErrorBase";
var ErrorConflictStrategy = (function (_super) {
    tslib_1.__extends(ErrorConflictStrategy, _super);
    function ErrorConflictStrategy() {
        return _super.call(this) || this;
    }
    ErrorConflictStrategy.prototype.resolveConflict = function (changedAsset, oldAsset, assetsDictionary, precedence) {
        throw new ErrorBase('Asset name collision while AssetLibrary.namingStrategy set to AssetLibrary.THROW_ERROR. Asset path: ' + changedAsset.adaptee.assetFullPath);
    };
    ErrorConflictStrategy.prototype.create = function () {
        return new ErrorConflictStrategy();
    };
    return ErrorConflictStrategy;
}(ConflictStrategyBase));
export { ErrorConflictStrategy };



// WEBPACK FOOTER //
// ../dist/lib/library/ErrorConflictStrategy.js